import styles from './styles.module.scss'

const SimpleCountdown = ({ text, hasHour, timeLeft }) => {
  return (
    <div className={styles.simpleLayout}>
      <p className={styles.text}>{text}</p>
      <div className={styles.countdown}>
        {hasHour && (
          <>
            <div className={styles.timer}>
              {timeLeft.hours.toString().padStart(2, '0')}
              <span>h</span>
            </div>
          </>
        )}
        <div className={styles.timer}>
          {timeLeft.minutes.toString().padStart(2, '0')}
          <span>m</span>
        </div>
        <div className={styles.timer}>
          {timeLeft.seconds.toString().padStart(2, '0')}
          <span>s</span>
        </div>
      </div>
    </div>
  )
}

export default SimpleCountdown
